export default __webpack_public_path__ + "static/media/130.fe3c097f.gif";